import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import styles from './ProsesPembayaran.module.css'
import { getVideos } from '../../store/features/CameraAndSignatureSlice'
import Header from '../../component/Header/header'
import ProgressBar from '../../component/ProgressBar/progressbar'
import { getIllustrationSPAJ } from '../../store/features/IllustrationSPAJSlice'
import { updateStatusSpaj } from '../../store/features/SPAJSlice'
import Spinners from '../../component/Spinner/spinners'
import { StatusCustomer, formatCurrency } from '../../component/Helper'
import { Row, Col } from 'react-bootstrap'

export default function LandingPage () {
  let dispatch = useDispatch()
  let [loading, setLoading] = useState(false)
  let navigate = useNavigate()
  const { SPAJDetail } = useSelector(state => state.SPAJsDetail)
  const { Ilustration } = useSelector(state => state.Ilustration)
  const { DeviceId } = useSelector(state => state.DeviceId)
  const { SPAJs } = useSelector(state => state.SPAJs)
  const [statusCustomer, setStatusCustomer] = useState('')
  useEffect(() => {
    setStatusCustomer(StatusCustomer(SPAJs.spajHeader.statusCustomer,SPAJs.spajHeader?.isUnitLink))
    if (statusCustomer >= 4) {
      if (statusCustomer == 4) {
        navigate('/proses-pembayaran')
      } else if (statusCustomer == 5) {
        navigate('/final-step')
      }
    }
  }, [SPAJs, statusCustomer])

  // useEffect(() => {
  //   setLoading(true)

  //   let dataIllustration = {
  //     deviceId: `${DeviceId.deviceId}`,
  //     userName: `${SPAJDetail.dataSpaj.email}`,
  //     spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`
  //   }
  //   dispatch(getIllustrationSPAJ(dataIllustration))
  //     .then(res => {
  //       setLoading(false)
  //     })
  //     .catch(err => {
  //       setLoading(false)
  //     })
  // }, [])

  const PremiTopUpBerkala = () =>{
    return(
      <>
      {SPAJs.spajHeader.isSyariah == 0 ? (<>
        <Row>
              <Col xs={12} sm={12} md={12} lg={4}>
                <div className='p-30 fs-20'>Premi Top Up Berkala</div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8}>
                <div className='border-pembayaran '>
                  {formatCurrency(
                    SPAJDetail.dataBenefitSpaj.basic.RTU,
                    true
                  )}
                </div>
              </Col>
          </Row>
      </>
      ):(
      <>
        <Row>
              <Col xs={12} sm={12} md={12} lg={4}>
                <div className='p-30 fs-20'>Kontribusi Top Up Berkala</div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8}>
                <div className='border-pembayaran '>
                  {formatCurrency(
                    SPAJDetail.dataBenefitSpaj.basic.RTU,
                    true
                  )}
                </div>
              </Col>
          </Row>
      </>)}
      </>
    )
  }

  const PremiRider = () =>{
    return(
      <>
      {SPAJs.spajHeader.isSyariah == 0 ? (<>
        <Row>
              <Col xs={12} sm={12} md={12} lg={4}>
                <div className='p-30 fs-20'>Premi Rider</div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8}>
                <div className='border-pembayaran'>
                  {formatCurrency(
                    // SPAJDetail.dataBenefitSpaj.basic.RiderPremium,
                    // true
                    SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP.transactionPlan != "undefined" ? JSON.stringify(dataBenefitSpaj.transactionPlan) === '{}' ? null: SPAJDetail.dataBenefitSpaj.basic.RiderPremium :null,
                    true
                  )}
                </div>
              </Col>
          </Row>
      </>
      ):(
      <>
        <Row>
              <Col xs={12} sm={12} md={12} lg={4}>
                <div className='p-30 fs-20'>Kontribusi Rider</div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8}>
                <div className='border-pembayaran'>
                  {formatCurrency(
                    SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP.transactionPlan != "undefined" ? JSON.stringify(dataBenefitSpaj.transactionPlan) === '{}' ? null: SPAJDetail.dataBenefitSpaj.basic.RiderPremium :null,
                    true
                  )}
                </div>
              </Col>
          </Row>
      </>)}
      </>
    )
  }

  const TopUpTunggal = () =>{
    return(
      <>
      {SPAJs.spajHeader.isSyariah == 0 ? (<>
        <Row>
              <Col xs={12} sm={12} md={12} lg={4}>
                <div className='p-30 fs-20'>Premi top up tunggal</div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8}>
                <div className='border-pembayaran'>
                  {formatCurrency(
                    // SPAJDetail.dataBenefitSpaj.basic.RiderPremium,
                    // true
                    SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP,
                    true
                  )}
                </div>
              </Col>
          </Row>
      </>
      ):(
      <>
        <Row>
              <Col xs={12} sm={12} md={12} lg={4}>
                <div className='p-30 fs-20'>Kontribusi top up tunggal</div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8}>
                <div className='border-pembayaran'>
                  {formatCurrency(
                    SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP,
                    true
                  )}
                </div>
              </Col>
          </Row>
      </>)}
      </>
    )
  }


  return (
    <>
      <div>
        <Header />
        <ProgressBar step='4' status={statusCustomer} isUnitlink={isUnitLink}/>
        <div>
          <div className='g-0 welcome-container'>
            <div className={`position-relative ${styles.bgContainer}`}>
              <div className='allCardGreyPembayaran'>
                <div className={styles.cardContainer}>
                  {
                    SPAJs.spajHeader.isUnitLink == 1 ?
                    (<>
                      {SPAJs.spajHeader.isSyariah == 1? (
                      <>
                        <Row>
                          <Col xs={12} sm={12} md={12} lg={4}>
                            <div className='p-30 fs-20'>Kontribusi Dasar</div>
                          </Col>
                          <Col xs={12} sm={12} md={12} lg={8}>
                            <div className='border-pembayaran '>
                              {formatCurrency(
                                SPAJDetail.dataBenefitSpaj.basic.TotalAnnualPremium,
                                true
                              )}
                            </div>
                          </Col>
                      </Row>
                      <div className='mt-20'>
                          <Row>
                            <Col xs={12} sm={12} md={12} lg={4}>
                              <div className='p-30 fs-20'>Total Kontribusi</div>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8}>
                              <div className='border-pembayaran '>
                                {formatCurrency(
                                  SPAJDetail.dataBenefitSpaj.basic.Premium,
                                  true
                                )}
                              </div>
                            </Col>
                          </Row>
                      </div>
                        {SPAJDetail.dataBenefitSpaj.basic.RTU && <PremiTopUpBerkala/>}
                        {SPAJDetail.dataBenefitSpaj.basic.RiderPremium != 0 && <PremiRider/>}
                        {SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP && <TopUpTunggal/>}
                      </>):(<>
                        <Row>
                          <Col xs={12} sm={12} md={12} lg={4}>
                            <div className='p-30 fs-20'>Premi Dasar</div>
                          </Col>
                          <Col xs={12} sm={12} md={12} lg={8}>
                            <div className='border-pembayaran '>
                              {formatCurrency(
                                SPAJDetail.dataBenefitSpaj.basic.TotalAnnualPremium,
                                true
                              )}
                            </div>
                          </Col>
                      </Row>
                      <div className='mt-20'>
                          <Row>
                            <Col xs={12} sm={12} md={12} lg={4}>
                              <div className='p-30 fs-20'>Total Premi</div>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8}>
                              <div className='border-pembayaran '>
                                {formatCurrency(
                                  SPAJDetail.dataBenefitSpaj.basic.Premium + (SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP ? (SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP):(0)) ,
                                  true
                                )}
                              </div>
                            </Col>
                          </Row>
                      </div>
                        {SPAJDetail.dataBenefitSpaj.basic.RTU && <PremiTopUpBerkala/>}
                        {SPAJDetail.dataBenefitSpaj.basic.RiderPremium != 0 && <PremiRider/>}
                        {SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP && <TopUpTunggal/>}
                      </>)}
                    </>):(<>
                    {
                      SPAJs.spajHeader.isSyariah == 1? (<>
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={4}>
                          <div className='p-30 fs-20'>Kontribusi Dasar</div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8}>
                          <div className='border-pembayaran '>
                            {formatCurrency(
                              SPAJDetail.dataBenefitSpaj.basic.TotalAnnualPremium,
                              true
                            )}
                          </div>
                        </Col>
                      </Row>
                      <div className='mt-20'>
                        <Row>
                          <Col xs={12} sm={12} md={12} lg={4}>
                            <div className='p-30 fs-20'>Total Kontribusi</div>
                          </Col>
                          <Col xs={12} sm={12} md={12} lg={8}>
                            <div className='border-pembayaran '>
                              {formatCurrency(
                                SPAJDetail.dataBenefitSpaj.basic.Premium,
                                true
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                      </>):(<>
                        <Row>
                          <Col xs={12} sm={12} md={12} lg={4}>
                            <div className='p-30 fs-20'>Premi Dasar</div>
                          </Col>
                          <Col xs={12} sm={12} md={12} lg={8}>
                            <div className='border-pembayaran '>
                              {formatCurrency(
                                SPAJDetail.dataBenefitSpaj.basic.TotalAnnualPremium,
                                true
                              )}
                            </div>
                          </Col>
                        </Row>
                        <div className='mt-20'>
                          <Row>
                            <Col xs={12} sm={12} md={12} lg={4}>
                              <div className='p-30 fs-20'>Total Premi</div>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8}>
                              <div className='border-pembayaran '>
                                {formatCurrency(
                                  SPAJDetail.dataBenefitSpaj.basic.Premium,
                                  true
                                )}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </>)
                    }

                    </>)
                  }
                  {/* <Row>
                    <Col xs={12} sm={12} md={12} lg={4}>
                      <div className='p-30 fs-20'>Premi Dasar</div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={8}>
                      <div className='border-pembayaran '>
                        {formatCurrency(
                          SPAJDetail.dataBenefitSpaj.basic.TotalAnnualPremium,
                          true
                        )}
                      </div>
                    </Col>
                  </Row>
                  <div className='mt-20'>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={4}>
                        <div className='p-30 fs-20'>Total Premi</div>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={8}>
                        <div className='border-pembayaran '>
                          {formatCurrency(
                            SPAJDetail.dataBenefitSpaj.basic.Premium,
                            true
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div> */}
                </div>
                <div
                  className={styles.pbotton}
                  style={{ display: 'flex', flexDirection: 'row' }}
                >
                  <div className={styles.buttonnext}>
                    <button
                      onClick={() => {
                        navigate('/pembayaran')
                      }}
                    >
                      Bayar
                    </button>
                  </div>
                  <div className={styles.buttonnext}>
                    <button
                      onClick={() => {
                        if (SPAJs.spajHeader?.isUnitLink == 0) {
                          navigate('/form-final-step')
                        } else if (SPAJs.spajHeader?.isUnitLink == 1) {
                          navigate('/final-step')
                        }
                      }}
                    >
                      Halamn5
                    </button>
                  </div>
                </div>
              </div>

              <div className={styles.logoLinkStep4}>
                <div>www.generali.co.id</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}